<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    [style.width.px]="sidenavWidth"
    [disableClose]="(isHandset$ | async) === false"
    >
    <mat-icon
      (click)="sidenavWidthChange()"
      class="absolute top-5 right-0 cursor-pointer"
      >{{ sideNavIsExpanded ? "chevron_left" : " chevron_right" }}</mat-icon
      >
      <div class="sidenav-inner-container">
        <mat-toolbar id="navbar-header-image" class="flex flex-col">
          <a id="home-navigation-link" routerLink="/"
            ><img class="header-image" src="assets/tirvis-logo-4c.svg"
          /></a>
        </mat-toolbar>
        <mat-divider></mat-divider>

        <mat-nav-list class="user-profile">
          <div class="user-profile__content">
            <mat-icon
              class="account-circle"
              fontIcon="account_circle"
            ></mat-icon>
            <div class="user-profile__identity">
              <div class="user-profile__name">{{ userData.name }}</div>
              <div class="user-profile__email">
                {{ userData.email }}
              </div>
            </div>
          </div>
        </mat-nav-list>
        <mat-divider></mat-divider>
        <side-navbar class="mr-2"></side-navbar>
        <div class="sidenav-settings">
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="language-selector-sidenav">
            <mat-select
              [value]="getCurrentLanguage()"
              (selectionChange)="switchLanguage($event.value)"
              disableRipple
              >
              <mat-select-trigger>
                <div class="flex items-center">
                  <mat-icon class="text-lg w-4 mr-1">language</mat-icon>
                  <span class="mr-1">{{ "app.language" | translate }}:</span>
                  <span>{{ getCurrentLanguageAbbrev() }}</span>
                </div>
              </mat-select-trigger>
              @for (lang of availableLanguages; track lang) {
                <mat-option
                  [value]="lang.code"
                  >
                  <div class="flex items-center">
                    <mat-icon class="text-lg w-4 h-4 mr-2">language</mat-icon>
                    <span>{{ lang.abbrev }}</span>
                  </div>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (userService.userIsAdmin) {
            <button
              id="admin-settings-button"
              mat-raised-button
              color="primary"
              [routerLink]="['/', 'settings']"
              >
              <mat-icon>settings</mat-icon> {{ "app.settings" | translate }}
            </button>
          }
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content
      [style.marginLeft.px]="(isHandset$ | async) ? '' : sidenavWidth"
      >
      <mat-toolbar color="">
        @if (isHandset$ | async) {
          <button
            type="button"
            aria-label="Toggle sidenav"
            mat-icon-button
            (click)="drawer.toggle()"
            >
            <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
          </button>
        }

        @if ((headline | async)?.image) {
          <img
            src="{{ (headline | async)?.image }}"
            alt=""
            (load)="setHeadlineImageVisibility($event, true)"
            (error)="setHeadlineImageVisibility($event, false)"
            />
        }
        <div class="toolbar-heading h-100 d-flex flex-column justify-content-center">
          @if ((headline | async)?.breadcrumbs?.length) {
            <nav class="toolbar-breadcrumbs" aria-label="Seitennavigation">
              <ol>
                @for (breadcrumb of (headline | async)?.breadcrumbs; track breadcrumb.label; let last = $last) {
                  <li>
                    @if (breadcrumb.route) {
                      <a class="toolbar-breadcrumbs__link" [routerLink]="breadcrumb.route">
                        {{ breadcrumb.label }}
                      </a>
                    } @else {
                      <span [attr.aria-current]="last ? 'page' : null">
                        {{ breadcrumb.label }}
                      </span>
                    }
                    @if (!last) {
                      <mat-icon aria-hidden="true">chevron_right</mat-icon>
                    }
                  </li>
                }
              </ol>
            </nav>
          } @else {
            <span innerHTML="{{ (headline | async)?.headline }}"></span>
            @if ((headline | async)?.subheadline) {
              <ol class="breadcrumb">
                @for (headline_text of (headline | async)?.subheadline; track headline_text) {
                  <li class="breadcrumb-item active">
                    {{ headline_text }}
                  </li>
                }
              </ol>
            }
          }
        </div>
      <div class="d-flex flex-row align-items-center ml-auto gap-4">
        <div
          (click)="userLogout()"
          id="logout-button"
          class="d-flex flex-row align-items-center"
          >
          <span>{{ "app.logout" | translate }}</span>
          <mat-icon>logout</mat-icon>
        </div>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
